// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"Input_inputWrapper__2525W","label":"Input_label__6TCqH","input":"Input_input__DVE_H","errorMsg":"Input_errorMsg__4jqhC","invalid":"Input_invalid__1fNLG"};